export default "__VITE_ASSET__6e8c96cb__"